export default __webpack_public_path__ + "static/media/G0860.Breech_Birth_Algorithm_-_Photos.1693835940000.11eb16c6.jpg";